/**
 * Code-native Google Ads Conversion Linker (TPD-573 Phase 7 / TPD-560).
 *
 * The first-party `_gcl_*` cookies (`_gcl_aw`, `_gcl_gb`, …) that EVERY offline
 * UPLOAD_CLICKS partner conversion depends on — kayak / skyscanner / expedia /
 * booking / momondo / mediaalpha / … (the revenue path) — were written ONLY by
 * the GTM "Conversion Linker" tag. With GTM removed, gclid capture must live in
 * code or partner offline conversions silently lose click attribution (the
 * migration's #1 revenue risk).
 *
 * GA4 is linked to Google Ads, but that link only enables conversion IMPORT —
 * writing the `_gcl_*` cookies is a gtag.js runtime behaviour. So we enable the
 * Conversion Linker EXPLICITLY on the GA4 Google tag (conversion_linker:true,
 * send_page_view:false so the extra config does not double-count page_view).
 * Set NEXT_PUBLIC_GOOGLE_ADS_ID to an `AW-XXXXXXXXX` tag id to use an explicit
 * Google Ads tag instead.
 *
 * Idempotent, client-only. MANDATORY before relying on it: verify in staging
 * that `?gclid=TEST123` writes a first-party `_gcl_aw` cookie (`GCL.<ts>.<gclid>`)
 * and that a partner redirect still carries the gclid for the offline upload.
 */

const GA4_MEASUREMENT_ID = 'G-RRHFY1EM93';

let linkerInstalled = false;

export function installConversionLinker(): void {
	if (typeof window === 'undefined' || linkerInstalled) return;

	const w = window as unknown as { gtag?: (...args: unknown[]) => void };
	if (typeof w.gtag !== 'function') return;

	linkerInstalled = true;

	const adsId = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;
	if (adsId) {
		w.gtag('config', adsId, { conversion_linker: true });
		return;
	}

	w.gtag('config', GA4_MEASUREMENT_ID, {
		conversion_linker: true,
		send_page_view: false,
	});
}
